import React from 'react';
import PropTypes from 'prop-types';
import { stringSeparatedWords } from '../helpers';

export const ClassDetailsVenueAddress = ({ venue }) => {
  const venueAddressline1 = stringSeparatedWords(', ', venue.address.address_line1, venue.address.address_line2);
  const venueAddressLine2 = stringSeparatedWords(', ', venue.address.city, venue.address.state, venue.address.zip_code);

  return (
    <div>
      {venueAddressline1}
      {venueAddressLine2 && (
        <>
          <br />
          {venueAddressLine2}
        </>
      )}
    </div>
  );
};

ClassDetailsVenueAddress.propTypes = {
  venue: PropTypes.object.isRequired,
};
